import { IsUUID, IsOptional, IsBoolean } from "class-validator";

export default class UnitUnit {
  @IsUUID("4")
  public readonly id!: string;

  @IsOptional()
  @IsBoolean()
  public is_template: boolean = false;

  @IsOptional()
  @IsBoolean()
  public is_archived: boolean = false;

  constructor(data?: any) {
    if (data) {
      if (typeof data.id === "string") {
        this.id = data.id;
      }

      if (typeof data.is_template === "boolean") {
        this.is_template = data.is_template;
      }

      if (typeof data.is_archived === "boolean") {
        this.is_archived = data.is_archived;
      }
    }
  }
}
